module.exports = __webpack_public_path__ + "static/media/myBet_1.c11d020d.mp3";